export function isHlsVideoUrl(src: string) {
  return /\.m3u8(?:$|[?#])/i.test(src);
}

export function isBufferedVideoEnd(currentTime: number, duration: number, bufferedEnd: number) {
  return (
    Number.isFinite(currentTime) &&
    Number.isFinite(duration) &&
    Number.isFinite(bufferedEnd) &&
    duration > 0 &&
    currentTime >= 0 &&
    duration - currentTime >= 0 &&
    duration - currentTime <= 0.25 &&
    bufferedEnd >= duration - 0.25
  );
}

// Bounded buffers prevent a gallery from downloading whole clips before playback.
export const hlsPlaybackConfig = {
  autoStartLoad: false,
  capLevelToPlayerSize: true,
  startLevel: 1,
  maxBufferLength: 12,
  maxMaxBufferLength: 24,
  backBufferLength: 8,
};
